export default class InrangePricing {
    id: number = 0;
    duration: number = 0;
    players: PlayerPriceBall[] = [];

    

    static from(json: string): InrangePricing {
        let model = Object.assign(new InrangePricing(), json);
        return model;
    }
}

export class PlayerPriceBall {
    price: number = 0;
    balls: number = 0;

    constructor(price: number = 0, balls: number = 0) {
        this.price = price;
        this.balls = balls;
    }
}
